// extracted by mini-css-extract-plugin
export default {"container":"MobileMenu_container__mjpdC","openContainer":"MobileMenu_openContainer__Fmltu"};